import { NotificationContainer } from "react-notifications"

import "react-notifications/lib/notifications.css"

export default NotificationContainer
